import React from "react"
import { useTranslation } from "react-i18next"

import { Select } from "components"
import classes from "./OfsLimit.module.scss"

const OfsLimit = props => {
  const { form, setForm } = props

  const [t] = useTranslation()

  const handleChangeLimit = (select) => {
    setForm(prev => ({
      ...prev,
      limit: select.value
    }))
  }

  const options = [
    { label: 40, value: 40 },
    { label: 80, value: 80 },
    { label: 100, value: 100 }
  ]

  const value =
    { label: form.limit, value: form.limit }

  return (
    <div className={classes["container"]}>
      <Select
        value={value}
        isSearchable={false}
        label={t("تعداد_سطر_ها")}
        noOptionsMessage={() => null}
        options={options}
        onChange={handleChangeLimit}
      />
    </div>
  )
}

export default OfsLimit